import { LAST24HOURS } from 'features/consults/utils/constants';
import { DATE_TIME_FORMAT, formatDate, subDays } from 'utils/dates';

// eslint-disable-next-line import/prefer-default-export
export const mapConsultFilters = ({
  fromCreatedAt,
  query,
  state,
  networkId,
  healthcareSystemId,
  facilityId,
  ...restFilters
}) => ({
  ...restFilters,
  query: query || null,
  state: state || null,
  fromCreatedAt:
    fromCreatedAt === LAST24HOURS
      ? formatDate(subDays(new Date(), 1), DATE_TIME_FORMAT)
      : fromCreatedAt,
  networkId,
  healthcareSystemId,
  facilityId,
});
